import { render, staticRenderFns } from "./mainSafetyHealthyTargetPopup.vue?vue&type=template&id=1cf469d2"
import script from "./mainSafetyHealthyTargetPopup.vue?vue&type=script&lang=js"
export * from "./mainSafetyHealthyTargetPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf469d2')) {
      api.createRecord('1cf469d2', component.options)
    } else {
      api.reload('1cf469d2', component.options)
    }
    module.hot.accept("./mainSafetyHealthyTargetPopup.vue?vue&type=template&id=1cf469d2", function () {
      api.rerender('1cf469d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/main/mainSafetyHealthyTargetPopup.vue"
export default component.exports